








































import { Component, Vue, Prop } from 'vue-property-decorator';
import { GQL_currentUnit_currentUnit } from '@/queries/__generated__/currentUnit';
import { SmartQuery } from 'vue-apollo-decorator';
import { CURRENT_UNIT } from '@/queries/Application';
import { GQL_sendAltinnTaxToFb_sendAltinnTaxToFb } from '@/queries/__generated__/sendAltinnTaxToFb';
import gql from 'graphql-tag';

const SEND_ALTINN_TAX_TO_FB = gql`
  mutation sendAltinnTaxToFb(
    $unitId: ID!,
    $calendarMonth: String!,
  ) {
    sendAltinnTaxToFb(
      input: {
        unitId: $unitId,
        calendarMonth: $calendarMonth,
      }
    ) {
      failures
      successes
    }
  }
`;


@Component
export default class AltinnSendTaxToFakturabankButton extends Vue {
  @Prop({ type: String, required: true }) private calendarMonth!: string;
  @SmartQuery(CURRENT_UNIT) private currentUnit!: GQL_currentUnit_currentUnit;

  private SEND_ALTINN_TAX_TO_FB = SEND_ALTINN_TAX_TO_FB;
  private feedback: GQL_sendAltinnTaxToFb_sendAltinnTaxToFb | null = null;
}
